import { isNil } from 'lodash';
import { TOOLTIP_POSITION } from 'taboola-ultimate-ui';
import { TooltipWrapper } from '../../../../../../../components/TooltipWrapper/TooltipWrapper';
import { FormattedMessage } from '../../../../../../taboola-common-frontend-modules/i18n';

const TooltipMessage = ({ accountNumericId }) => {
    return (
        <div>
            <b>Account ID:</b> {accountNumericId != null ? accountNumericId : 0}
        </div>
    );
};

export const PushApiAccountNameCellRenderer = ({ data }) => {
    return (
        <TooltipWrapper
            tooltipContent={<TooltipMessage accountNumericId={data?.accountNumericId} />}
            tooltipOptions={{ arrow: true, placement: TOOLTIP_POSITION.TOP }}
        >
            {!isNil(data.accountName) ? (
                data.accountName
            ) : (
                <FormattedMessage
                    id="app.campaigns.reports.push-api.report.listen.to.column"
                    defaultMessage="All Accounts"
                />
            )}
        </TooltipWrapper>
    );
};
